var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"outline":""}},[_c('div',{staticClass:"tw-flex tw-items-center tw-justify-center tw-gap-2"},[_c('CLink',{staticClass:"tw-text-blue-600 tw-font-semibold tw-text-center",attrs:{"to":{
        name: '__classifieds_wanted_parts_new_form',
        params: {
          categoryId: _vm.CategoryId.WANTED_PARTS
        }
      }}},[_vm._v(_vm._s(_vm.$t('go_to_wanted_parts')))]),_vm._v(" "),_c('CInfoModal',{attrs:{"force-blue":""}},[_vm._v(_vm._s(_vm.$t('wanted_parts_description')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }